
import { Component, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { TableHeaderConfig } from '@/views/interfaces/vuetify/table.interface';
import DossierFeedbackReviewRepositoryInterface, {
  ReviewCategoryInterface,
} from '@/services/Dossier/review/interfaces';

@Component({
  mixins: [
    Themeable,
  ],
  inject: [
    'dossierFeedbackReviewRepository',
  ],
})
export default class ReviewCategories extends Vue {
  private dossierFeedbackReviewRepository!: DossierFeedbackReviewRepositoryInterface;

  private loading: boolean = true;

  private categories: ReviewCategoryInterface[] = [];
  private headers: TableHeaderConfig[] = [
    { text: 'ID', value: 'id' },
    { text: 'Name', value: 'name' },
  ];

  private categoryName: string = '';

  private async created(): Promise<void> {
    await this.initialize();
  }

  private async initialize(): Promise<void> {
    try {
      this.categories = await this.dossierFeedbackReviewRepository.getReviewCategories();
      this.loading = false;
    } catch (e) {
      this.$errorDialog.show(e?.response?.data?.message || e.message);
    }
  }

  private async createCategory(): Promise<void> {
    if (this.categoryName.trim() === '') {
      return;
    }

    try {
      const category = await this.dossierFeedbackReviewRepository.createReviewCategory(this.categoryName.trim());
      this.categories.push(category);
      this.$successDialog.show('Category created successfully!');
    } catch (e) {
      this.$errorDialog.show(e?.response?.data?.message || e.message);
    }
  }
}
